// test1839
(1839 && 0);
